export default __webpack_public_path__ + "static/media/DK_Layout_5.5d6ef57c.png";